import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'// 主体
import Index from '../views/index/index.vue'// 首页
import productservice from '../views/productservice/productservice.vue'// 证书
import integrated from '../views/integrated/integrated'// 一体化
import date from '../views/data/data_old'// 大数据
import cooperation from '../views/cooperation/cooperation.vue'//解决方案
import about from '../views/about/about.vue'//我们
import moindex from '../views/mobile/index/index.vue'
import homepage from '../views/page/homepage.vue'
// import moproductservice from '../views/mobile/productservice/productservice'
import hoproductservicepage from '../views/page/productservicepage'// 电子证书
import hodate from '../views/page/date.vue'
import cooperationpage from '../views/page/cooperation.vue'
import integratedpage from '../views/page/integrated'
import aboutpage from '../views/page/about'
import visualizationpage from '../views/page/visualizationpage' 
import pricepage from '../views/page/pricepage'
import payment from '../views/mobile/visual/payment.vue'
Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    redirect: '/index'
  },
  // {
  //   path: '/moproductservice',// 
  //   component: moproductservice
  // },
  {
    path: "/aboutpage",
    component: aboutpage
  },
  {
    path: "/cooperationpage",
    component: cooperationpage
  },
  {
    path: "/hoproductservicepage",
    component: hoproductservicepage
  },
  {
    path: "/integratedpage",
    component: integratedpage
  },
  {
    path: "/hodate",
    component: hodate
  },
  {
    path: "/visualizationpage",
    component: visualizationpage
  },
  {
    path: "/pricepage",
    component: pricepage
  },
  {
    path: '/payment',
    component: payment
  },
  {
    path: '/',
    name: 'Home',
    component: homepage,
    children: [{
      path: "/index",
      component: Index,
      meta: { show: false }
    }, {
      path: "/productservice",
      component: productservice,
      meta: { show: true }
    },
    {
      path: "/cooperation",
      component: cooperation,
      meta: { show: true }
    },
    {
      path: "/about",
      component: about,
      meta: { show: true }
    },
    {
      path: "/document",
      component: document
    },
    {
      path: "/integrated",
      component: integrated,
      meta: { show: true }
    },
    {
      path: "/data",
      component: date,
      meta: { show: true },
    }, {
      path: '/moindex',
      component: moindex
    },
    {
      path: '/visibilization',
      component: () => import('../views/visual/index.vue'),
      meta: { show: true }
    },
    {
      path: '/visibilization/price',
      component: () => import('../views/visual/price.vue'),
      meta: { show: true }
    },
    ]
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
